import { render, staticRenderFns } from "./OpinionTopics.vue?vue&type=template&id=44ffcab9&"
import script from "./OpinionTopics.vue?vue&type=script&lang=js&"
export * from "./OpinionTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports